export default __webpack_public_path__ + "static/media/slice-sidebar-layers.f0e4c510.png";